/* eslint-disable no-unused-vars */
/* eslint-disable react/no-string-refs */
import React, { Component } from 'react';

import Popup from '../../../../Popup';
import CheckboxSA from '../../../../FormElementsStandalone/CheckboxSA';

import styles from '../../../../../pages/ClubProfiles/club.scss';

class MembersBulkActions extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showConfirmationPopup: false,
        };

        this.showConfirmationPopup = this.showConfirmationPopup.bind(this);
    }

    showConfirmationPopup(type) {
        switch (type) {
            case 'remove':
                this.setState({
                    showConfirmationPopup: true,
                    warning: 'Are you sure you want to Remove Members?',
                    confirmAction: () => {
                        this.props.removeMembers();
                        this.showConfirmationPopup();
                    },
                });
                break;
            case 'physical':
                this.setState({
                    showConfirmationPopup: true,
                    warning: 'Are you sure you want to change to Physical Members?',
                    confirmAction: () => {
                        this.props.changeMembershipType('physical');
                        this.showConfirmationPopup();
                    },
                });
                break;
            case 'digital':
                this.setState({
                    showConfirmationPopup: true,
                    warning: 'Are you sure you want to change to Digital Members?',
                    confirmAction: () => {
                        this.props.changeMembershipType('digital');
                        this.showConfirmationPopup();
                    },
                });
                break;
            default:
                this.setState({
                    showConfirmationPopup: false,
                    warning: '',
                    confirmAction: null,
                });
        }
    }

    render() {
        const { showBulkActions } = this.props;
        return (
            <div>
                {showBulkActions && (
                    <div className={`${styles.titleContainer} ${styles.filterContainer} row bb mt0 mb16 d-none d-md-flex`}>
                        <div className={`col-4 pb8 fs13 text-dark text-medium`}>Selected  Actions</div>
                        <div className={`col-8 text-right`}>
                            <a
                                className="pr16 mr16 br fs13 text-medium text-dark clickable"
                                onClick={() => this.showConfirmationPopup('remove')}
                            >
                                <i className="utr utr-people text-teal mr4" /> Remove Members
                            </a>
                            <a
                                className="pr16 mr16 br fs13 text-medium text-dark clickable"
                                onClick={() => this.showConfirmationPopup('physical')}
                            >
                                <i className="uts uts-refresh text-teal mr4" /> Change to Physical
                            </a>
                            <a
                                className="fs13 text-medium text-dark clickable"
                                onClick={() => this.showConfirmationPopup('digital')}
                            >
                                <i className="uts uts-refresh text-teal mr4" /> Change to Digital
                            </a>
                        </div>
                    </div>
                )}
                <div className={`${styles.titleContainer} ${styles.filterContainer} row bb mt0 mb16 d-flex d-md-none`}>
                    <div className={`col-5 pb8 fs13 text-dark text-medium`}>
                        {showBulkActions ? <div>Selected Actions</div> : <div>&nbsp;</div>}
                    </div>
                    {showBulkActions && (
                        <div className={`col-7 d-flex flex-column`}>
                            <a
                                className="fs13 text-medium text-dark clickable"
                                onClick={() => this.showConfirmationPopup('remove')}
                            >
                                <i className="utr utr-people text-teal mr4" /> Remove Members
                            </a>
                            <a
                                className="fs13 text-medium text-dark clickable"
                                onClick={() => this.showConfirmationPopup('physical')}
                            >
                                <i className="uts uts-refresh text-teal mr4" /> Change to Physical
                            </a>
                            <a
                                className="fs13 text-medium text-dark clickable"
                                onClick={() => this.showConfirmationPopup('digital')}
                            >
                                <i className="uts uts-refresh text-teal mr4" /> Change to Digital
                            </a>
                        </div>
                    )}
                </div>
                {this.state.showConfirmationPopup && (
                    <Popup
                        className="popup-md"
                        onCloseClick={() => {
                            this.showConfirmationPopup();
                        }}
                        config={{
                            fullScreen: false,
                            noPadding: true,
                            gradient: true,
                            scrollable: false,
                        }}
                    >
                        <div className="popup-section p24 pt0 pb0">
                            <h5 className="text-dark mb0">
                                Warning!
                            </h5>
                        </div>
                        <div className="popup-section p24 text-dark">
                            <p>
                                {this.state.warning}
                            </p>
                            <div className="mt24">
                                <div className="row">
                                    <div className={`col-md-6`}>
                                        <button
                                            type="button"
                                            className="btn btn-default text-uppercase btn-block mb16"
                                            onClick={() => {
                                                this.showConfirmationPopup();
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                    <div className={`col-md-6`}>
                                        <button
                                            type="button"
                                            className="btn btn-primary text-uppercase btn-block"
                                            onClick={this.state.confirmAction}
                                        >
                                            Yes
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Popup>
                )}
            </div>
        );
    }
}

export default MembersBulkActions;
